import Vue from 'vue';

import qdNumberinput from '@/components/qdEncapsulation/qdNumberinput';
import qdRadio from './qdRadio';
import qdRadioButton from './qdRadioButton';
import qdProgress from './qdProgress';
import qdNotification from './qdNotification';
import qdSteps from './qdSteps';
import qdTaginput from './qdTaginput';
import qdCollapse from './qdCollapse';
import qdIcon from './qdIcon';
import qdDropdown from './qdDropdown';
import qdMessage from './qdMessage';
import qdButton from './qdButton';
import qdLoading from './qdLoading';
import qdLoader from './qdLoader';
import qdSwitch from './qdSwitch';
import qdCheckbox from './qdCheckbox';

Vue.component('qdRadio', qdRadio);
Vue.component('qdRadioButton', qdRadioButton);
Vue.component('qdProgress', qdProgress);
Vue.component('qdNotification', qdNotification);
Vue.component('qdSteps', qdSteps);
Vue.component('qdTaginput', qdTaginput);
Vue.component('qdCollapse', qdCollapse);
Vue.component('qdNumberinput', qdNumberinput);
Vue.component('qdIcon', qdIcon);
Vue.component('qdDropdown', qdDropdown);
Vue.component('qdMessage', qdMessage);
Vue.component('qdButton', qdButton);
Vue.component('qdLoading', qdLoading);
Vue.component('qdLoader', qdLoader);
Vue.component('qdSwitch', qdSwitch);
Vue.component('qdCheckbox', qdCheckbox);
